module.exports = __webpack_public_path__ + "img/image_40.7783429c.png";